import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API, authHeaders, fmtErr, fmtDate } from '../../lib/auth';

export const FormTab = ({ subs, loadSubs, flash }) => {
  const [busy, setBusy] = useState(false);
  const linkSubs = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/user/link-submissions`, {}, { headers: authHeaders() });
      flash(data.linked ? `${data.linked} earlier form(s) linked to your account.` : 'No unlinked forms found for your email/mobile.');
      loadSubs();
    } catch (err) { flash(fmtErr(err.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <div className="dash-card" data-testid="form-section">
      <h3>My Match Form</h3>
      {subs.length === 0 ? (
        <div>
          <p style={{ color: 'var(--muted)', fontSize: 14 }}>You haven't submitted a matchmaking form yet — or your earlier guest form isn't linked.</p>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 12 }}>
            <Link to="/#match" className="btn btn-red btn-sm">Fill My Match Form</Link>
            <button className="btn btn-ghost btn-sm" onClick={linkSubs} disabled={busy} data-testid="link-subs-btn">Link my earlier form</button>
          </div>
        </div>
      ) : subs.map((s) => (
        <div key={s.id} data-testid={`my-submission-${s.id}`} className="dash-sub" style={{ display: 'block' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
            <div>
              <b>{s.plan_name}</b> · {s.plan_price}
              <div style={{ fontSize: 12, color: 'var(--muted)' }}>Submitted {fmtDate(s.submitted_at)} · ID {s.id.slice(0, 8).toUpperCase()}</div>
            </div>
            <span className="pay-badge">{s.match_status}</span>
          </div>
          <div className="review-grid" style={{ marginTop: 12 }}>
            {Object.entries(s.data || {}).filter(([, v]) => v && (Array.isArray(v) ? v.length : String(v).trim())).map(([k, v]) => (
              <div className="review-item" key={k}>
                <span className="rlabel">{k.replace(/([A-Z])/g, ' $1').replace(/^./, (c) => c.toUpperCase())}</span>
                <span className="rval">{Array.isArray(v) ? v.join(', ') : String(v)}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FormTab;
